import React from 'react';

const SKELENON_LENGTH = 12;

const ProductListSkeleton = () => {
    return (
        <div className="product-list-cards grid" aria-live="polite">
            <ul className="product-list-cards__list row">

                {[...Array(SKELENON_LENGTH)].map((val, index) => (
                    <SkeletonItem key={index} />
                ))}

            </ul>
        </div>
    );
};

const SkeletonItem = () => {
    return (
        <li className="product-list-cards__col col col-xs-12 col-sm-4 col-md-3" >
            <div className="product-card product-card--skeleton">
                <div className="product-card__header">
                    <div className="product-card__image"></div>
                </div>
                <div className="product-card__info">
                    <div className="product-card__title"></div>
                    <div className="product-card__price"></div>
                    <div className="product-card__details">
                        <div className="product-card__detail-link"></div>
                    </div>
                </div>
            </div>
        </li>
    );
};

export default ProductListSkeleton;
